export default __webpack_public_path__ + "media/icons/shop-icon-active-fcf8ae2b.svg";